import AppIcon from "@/components/AppIcon.vue";
import FlexRow from "@/components/FlexRow.vue";
import CircularIndicator from "./CircularIndicator.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import Icons from "@/components/icons";
export default {
  name: "FilterItemSelector",
  components: {
    ...Icons,
    AppIcon,
    FlexRow,
    CircularIndicator,
    WrapWithPopover
  },
  emits: ['clearAll', 'apply', 'click'],
  props: {
    id: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#4D4D4D"
    },
    iconSize: {
      type: Number
    },
    title: {
      type: String,
      default: ""
    },
    selectedTitle: {
      type: String,
      default: ""
    },
    selectedCount: {
      type: Number,
      default: 0
    },
    noCaret: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noCount: {
      type: Boolean,
      default: false
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hovered: false
    };
  },
  computed: {
    getSelectedCount() {
      if (this.selectedCount > 9) {
        return '9+';
      } else {
        return this.selectedCount;
      }
    },
    hasPopover() {
      return this.selectedCount > 0 && !!this.selectedTitle;
    }
  },
  methods: {
    // Reset the selection, then apply so the parent's apply[Name] handler
    // refreshes the dashboard immediately (clear then apply, in sequence).
    clearAndApply() {
      this.$emit('clearAll');
      this.$emit('apply');
    }
  }
};